var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.50004 15.4167C1.50004 16.425 2.32504 17.25 3.33337 17.25H10.6667C11.675 17.25 12.5 16.425 12.5 15.4167V4.41667H1.50004V15.4167ZM13.4167 1.66667H10.2084L9.29171 0.75H4.70837L3.79171 1.66667H0.583374V3.5H13.4167V1.66667Z",
    fill: "#989898"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkTrash);
export default __webpack_public_path__ + "static/media/darkTrash.18cb92f7938c72c4eb59a3e0a7d3874c.svg";
export { ForwardRef as ReactComponent };